import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import { parseServerDate, todayLocalStr } from '../utils/dateUtils';

function daysAgoLocalStr(days) {
  var d = new Date();
  d.setDate(d.getDate() - days);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

export default function AccountStatement() {
  var id = useParams().id;
  var navigate = useNavigate();
  var _account = useState(null), account = _account[0], setAccount = _account[1];
  var _transactions = useState([]), transactions = _transactions[0], setTransactions = _transactions[1];
  var _startDate = useState(daysAgoLocalStr(30)), startDate = _startDate[0], setStartDate = _startDate[1];
  var _endDate = useState(todayLocalStr()), endDate = _endDate[0], setEndDate = _endDate[1];
  var _loading = useState(true), loading = _loading[0], setLoading = _loading[1];

  useEffect(function() { fetchStatement(); }, [id]);

  function fetchStatement() {
    setLoading(true);
    api.get('/accounts/' + id + '/statement?startDate=' + startDate + '&endDate=' + endDate)
      .then(function(res) {
        setAccount(res.data.account);
        setTransactions(res.data.transactions);
        setLoading(false);
      })
      .catch(function() {
        setLoading(false);
      });
  };

  var fmt = function(n) { return '₹' + (n || 0).toLocaleString('en-IN'); };

  return (
    <div>
      <button onClick={() => navigate('/accounts')} style={{ color: '#2563eb', background: 'none', border: 'none', cursor: 'pointer', marginBottom: 16, fontSize: 16 }}>← Back to Accounts</button>

      {loading && <div style={{ textAlign: 'center', padding: 40 }}>Loading...</div>}

      {!loading && account && (
        <div>
          <div style={{ background: 'white', borderRadius: 12, padding: 24, marginBottom: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h2 style={{ fontSize: 24, fontWeight: 'bold', margin: 0 }}>{account.name}</h2>
                <span style={{ fontSize: 14, color: '#6b7280', textTransform: 'capitalize' }}>{account.type}</span>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ fontSize: 14, color: '#6b7280', margin: 0 }}>Current Balance</p>
                <p style={{ fontSize: 32, fontWeight: 'bold', color: '#2563eb', margin: 0 }}>{fmt(account.balance)}</p>
              </div>
            </div>
          </div>

          <div style={{ background: 'white', borderRadius: 8, padding: 16, marginBottom: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'end' }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 500, display: 'block', marginBottom: 4 }}>Start Date</label>
                <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: 6 }} />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 500, display: 'block', marginBottom: 4 }}>End Date</label>
                <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={{ padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: 6 }} />
              </div>
              <button onClick={fetchStatement} style={{ background: '#2563eb', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>Apply</button>
            </div>
          </div>

          <div style={{ background: 'white', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr style={{ background: '#f9fafb' }}>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 500, color: '#6b7280' }}>Date & Time</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 500, color: '#6b7280' }}>Description</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 500, color: '#6b7280' }}>Type</th>
                  <th style={{ padding: '10px 16px', textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#6b7280' }}>Debit</th>
                  <th style={{ padding: '10px 16px', textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#6b7280' }}>Credit</th>
                  <th style={{ padding: '10px 16px', textAlign: 'right', fontSize: 12, fontWeight: 500, color: '#6b7280' }}>Balance</th>
                </tr>
              </thead>
              <tbody>
                {transactions.length === 0 && (
                  <tr><td colSpan={6} style={{ textAlign: 'center', padding: 32, color: '#6b7280' }}>No transactions found</td></tr>
                )}
                {transactions.map(tx => (
                  <tr key={tx.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <td style={{ padding: '10px 16px', fontSize: 13 }}>{parseServerDate(tx.created_at).toLocaleString('en-IN')}</td>
                    <td style={{ padding: '10px 16px' }}>{tx.description}</td>
                    <td style={{ padding: '10px 16px' }}>
                      <span style={{ padding: '2px 8px', borderRadius: 12, fontSize: 11, fontWeight: 500, background: tx.type === 'credit' ? '#dcfce7' : '#fee2e2', color: tx.type === 'credit' ? '#16a34a' : '#dc2626' }}>
                        {tx.type.toUpperCase()}
                      </span>
                    </td>
                    <td style={{ padding: '10px 16px', textAlign: 'right', color: '#dc2626' }}>{tx.type === 'debit' ? fmt(tx.amount) : '-'}</td>
                    <td style={{ padding: '10px 16px', textAlign: 'right', color: '#16a34a' }}>{tx.type === 'credit' ? fmt(tx.amount) : '-'}</td>
                    <td style={{ padding: '10px 16px', textAlign: 'right', fontWeight: 600 }}>{fmt(tx.running_balance)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
